import MoneyRendererV3 from '@components/Money/MoneyRendererV3/MoneyRendererV3';
import { MoneyRendererV3DirectionEnum } from '@components/Money/MoneyRendererV3/moneyRendererV3.types';
import Typography from '@components/v2/ui/Typography/Typography';
import LangEnum from '../../../../../../../lang/LangEnum';
import MarkupChip from '../../../../../../products/MarkupChip';
import { useTranslation } from '../../../../../../translation/TranslationContext';
import { ProductCardsPriceConfig } from '../../productCardsBlock.types';
import {
  PRODUCT_CARDS_MARKUP_FONT_SIZE,
  useProductCardsPriceStyles,
} from './productCardsPrice.styles';
import { useProductCardsPrice } from './useProductCardsPrice';

type ProductCardsPriceProps = Omit<ProductCardsPriceConfig, 'isVisible'>;

const ProductCardsPrice = ({
  prices,
  isRetailDisabled,
  isWholesaleDisabled,
}: ProductCardsPriceProps) => {
  const { translate } = useTranslation();
  const { classes } = useProductCardsPriceStyles();
  const { hasPrices, wholesale, retail } = useProductCardsPrice({
    prices,
    isRetailDisabled,
    isWholesaleDisabled,
  });

  if (!hasPrices) {
    return (
      <Typography variant="body2" color="textSecondary">
        {translate(LangEnum.PRODUCT_DETAILS_UNAVAILABLE_GRID)}
      </Typography>
    );
  }

  return (
    <div className={classes.card}>
      {wholesale && (
        <MoneyRendererV3
          direction={MoneyRendererV3DirectionEnum.ROW}
          size="medium"
          value={wholesale.value}
          promotionValue={wholesale.promotionValue}
        />
      )}
      {retail && (
        <div className={classes.retail}>
          <MoneyRendererV3 color="textSecondary" size="small" value={retail.value} />
          {!!retail.markup && (
            <MarkupChip
              markupValue={retail.markup}
              fontSize={PRODUCT_CARDS_MARKUP_FONT_SIZE}
              className={classes.markup}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default ProductCardsPrice;
